//@flow
import Model from '../../Utils/Model/model';

import type { GiftParams } from '../Quote/quoteItemModel';

export type OrderItemObject = {
  id:string,
  product_id:string,
  sku:string,
  name:string,
  description:?string,
  qty_canceled:number,
  qty_invoiced:number,
  qty_ordered:number,
  qty_refunded:number,
  qty_shipped:number,
  price:number,
  row_total:number,
  price_incl_tax:number,
  row_total_incl_tax:number,
  params:$Shape<GiftParams>,
  product_type:'giftvoucher'|'simple'|'package'|'snackpass',
  is_virtual:boolean,
};

export default class OrderItemModel extends Model<OrderItemObject> {
  getItemId() {
    return this.attributes.id;
  }

  getProductId() {
    return this.attributes.product_id;
  }

  getSku() {
    return this.attributes.sku;
  }

  getName() {
    return this.attributes.name;
  }

  getDescription() {
    return this.attributes.description || undefined;
  }

  getQtyInvoiced() {
    return this._getFloat(this.attributes.qty_invoiced);
  }

  getQtyCanceled() {
    return this._getFloat(this.attributes.qty_canceled);
  }

  getQtyOrdered() {
    return this._getFloat(this.attributes.qty_ordered);
  }

  getQtyRefunded() {
    return this._getFloat(this.attributes.qty_refunded);
  }

  getQtyShipped() {
    return this._getFloat(this.attributes.qty_shipped);
  }

  getParams():GiftParams {
    return this.attributes.params;
  }

  isGiftVoucher():boolean {
    return this.attributes.product_type === 'giftvoucher' || false;
  }

  isSnackpass():boolean {
    return this.attributes.product_type === 'snackpass';
  }

  //if regular price is available, it is the correct pre discount price, if it's not,
  //then price is.
  getPrice() {
    return this._getFloat(this.attributes.price);
  }

  getPriceInclTax() {
    return this._getFloat(this.attributes.price_incl_tax);
  }

  // Leaving this fuction so the QuoteItemModel and OrderItemModel can have a similar structure.
  getQty():number {
    return this.getQtyOrdered() || 0;
  }
}
